import React from 'react';
import { Column } from '@tanstack/react-table';
import { ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react';
import { Button } from '@predoc/cow';

interface SortableHeaderProps<TData> {
  column: Column<TData>;
  children: React.ReactNode;
}

export const SortableHeader = <TData,>({
  column,
  children,
}: SortableHeaderProps<TData>) => {
  const isSorted = column.getIsSorted();

  return (
    <Button
      variant="ghost"
      onClick={column.getToggleSortingHandler()}
      className="flex h-auto items-center gap-1 p-0 text-left whitespace-normal hover:bg-transparent"
    >
      {children}
      {isSorted === 'asc' ? (
        <ArrowUp className="size-3 text-gray-400" />
      ) : isSorted === 'desc' ? (
        <ArrowDown className="size-3 text-gray-400" />
      ) : (
        <ChevronsUpDown className="size-3 text-gray-400" />
      )}
    </Button>
  );
};
